export default "__VITE_ASSET__ead1bd34__"